import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ExternalLink } from "lucide-react";
import SEO from "../components/SEO";

function ArticlesGrid({ section, accent, eyebrow, title, intro, mode = "wealth" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/articles?section=${section}`).then(r => setItems(r.data)).catch(() => {});
  }, [section]);

  const dark = mode === "wealth";

  return (
    <div className={`min-h-screen ${dark ? "bg-[#1A2E1A] text-white" : "bg-[#F9FAF6] text-[#1A2E1A]"}`} data-testid={`${section}-page`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-20 lg:py-32">
        <div className={`text-xs font-bold tracking-[0.3em] uppercase mb-4`} style={{ color: accent }}>{eyebrow}</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">{title}</h1>
        <p className={`mt-4 max-w-2xl text-lg ${dark ? "text-[#9DB59D]" : "text-[#4B634B]"}`}>{intro}</p>

        {/* Bento grid */}
        <div className="grid md:grid-cols-3 lg:grid-cols-4 auto-rows-[260px] gap-5 mt-14">
          {items.map((a, idx) => {
            const big = idx % 5 === 0;
            return (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                data-testid={`article-card-${a.id}`}
                className={`group relative overflow-hidden rounded-3xl border ${dark ? "border-white/10" : "border-[#E5EAE5]"} ${big ? "md:col-span-2 md:row-span-2" : ""}`}
              >
                <img src={a.cover_image} alt={a.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  {a.external_link && (
                    <div className="inline-flex items-center gap-1 text-[10px] font-bold tracking-[0.2em] uppercase mb-2" style={{ color: accent }}>
                      <ExternalLink className="w-3 h-3" /> Ressource externe
                    </div>
                  )}
                  <h3 className={`font-black tracking-tight ${big ? "text-2xl lg:text-3xl" : "text-lg"}`}>{a.title}</h3>
                  {big && <p className="text-sm text-white/80 mt-2 line-clamp-2">{a.excerpt}</p>}
                </div>
              </Link>
            );
          })}
          {items.length === 0 && <p className={`col-span-full text-center py-20 ${dark ? "text-[#9DB59D]" : "text-[#4B634B]"}`}>Aucun article pour l'instant.</p>}
        </div>
      </div>
    </div>
  );
}

export function WealthGuide() {
  return (
    <>
      <SEO pageSlug="healthy-guides" title="Healthy Guides" description="Conseils nutrition, routines saines et inspirations pour une vie plus équilibrée au quotidien." path="/healthy-guides" />
      <ArticlesGrid
        section="wealth"
        accent="#FACC15"
        eyebrow="Healthy Guides"
        title="Prenez soin de votre bien-être."
        intro="Conseils nutrition, routines saines et inspirations pour une vie plus équilibrée au quotidien."
        mode="wealth"
      />
    </>
  );
}

export function KitchenCorner() {
  return (
    <>
      <SEO pageSlug="kitchen-corner" title="Kitchen Corner" description="Des recettes simples, gourmandes et nutritives pour intégrer le bien-être au quotidien." path="/kitchen-corner" />
      <ArticlesGrid
        section="kitchen"
        accent="#7AC143"
        eyebrow="Kitchen Corner"
        title="Recettes saines, énergie vibrante."
        intro="Des recettes simples, gourmandes et nutritives pour intégrer le bien-être au quotidien."
        mode="kitchen"
      />
    </>
  );
}
